import {Parameters, postsClient} from "../posts-client/posts-client"

export {}

const reInitializations = () => {
  document.dispatchEvent(new Event("baseformReinit"))
  document.dispatchEvent(new Event("postsReinit"))
  document.dispatchEvent(new Event("lazyloadReinit"))
  document.dispatchEvent(new Event("cursorInit"))
}

document.querySelectorAll(".s-posts-list").forEach((section) => {
  const buttonLoad = section.querySelector<HTMLElement>(".--js-load-more")
  const buttonsGroup = section.querySelector(".s-posts-list__buttons")
  const postsGroup = section.querySelector(".g-posts")

  const getCategory = () => {
    return section.querySelector<HTMLInputElement>(".s-posts-list__tags.--categories .i-tag__input:checked, .s-posts-list__category-input")
      ?.value
  }

  const getHastag = () => {
    return section.querySelector<HTMLInputElement>(".s-posts-list__tags.--hashtags .i-tag__input:checked, .s-posts-list__hastag-input")
      ?.value
  }
  const getAuthor = () => section.querySelector<HTMLInputElement>(".s-posts-list__author-input")?.value

  const getSearchQuery = () => section.querySelector<HTMLInputElement>(".s-posts-list__search-query-input")?.value

  const getLimit = () => section.querySelector<HTMLInputElement>(".s-posts-list__limit-input")?.value

  const getNewsletter = () => section.querySelector<HTMLInputElement>(".s-posts-list__newsletter-input")?.value

  const getPage = () => Number(buttonLoad?.dataset.page ?? 2)

  const getParameters = (page: number) => {
    const parameters: Parameters = {
      page: page,
      limit: getLimit() ? Number(getLimit()) : undefined,
      category: getCategory(),
      author: getAuthor(),
      search: getSearchQuery(),
      hashtag: getHastag(),
      newsletter: getNewsletter(),
    }

    return parameters
  }

  const addLoading = () => {
    postsGroup?.classList.add("--loading")
    buttonsGroup?.classList.add("--loading")
  }

  const removeLoading = () => {
    postsGroup?.classList.remove("--loading")
    buttonsGroup?.classList.remove("--loading")
  }

  // Load more handle
  buttonLoad?.addEventListener("click", async () => {
    addLoading()
    const currentPage = getPage()
    const data = await postsClient.list(getParameters(currentPage))

    if (!data) {
      removeLoading()
      return
    }

    postsGroup?.insertAdjacentHTML("beforeend", data.items) // Add to items to group
    buttonLoad.dataset.page = String(currentPage + 1)
    buttonsGroup?.classList.toggle("d-none", !data.isLoadMore) // Show loadmore if is more to load
    reInitializations()
    removeLoading()
  })

  // Filtration handle
  section.querySelectorAll<HTMLInputElement>(".i-tag.--input .i-tag__input").forEach((input) => {
    input.addEventListener("change", async () => {
      addLoading()
      const data = await postsClient.list(getParameters(1))

      if (!data) {
        removeLoading()
        return
      }

      if (postsGroup) postsGroup.innerHTML = data.items
      reInitializations()
      buttonsGroup?.classList.toggle("d-none", !data.isLoadMore)
      if (buttonLoad) buttonLoad.dataset.page = String(2)
      removeLoading()
    })
  })
})
